import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { RepairCard } from './RepairCard';
import { Repair } from '../../../data/Repair';

type RepairCardListProps = {
    repairList: Repair[],
    onClick: (repair: Repair) => void,
};

RepairCardList.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
}));

function RepairCardList(props: RepairCardListProps): React.ReactElement {
    const {
        repairList,
        onClick,
    } = props;
    const classes = useStyle();

    return (
        <div className={classes.root}>
            {repairList.map((repair) => (
                <RepairCard onClick={() => onClick(repair)} repair={repair} />
            ))}
        </div>
    );
}

export { RepairCardList };
